/*
 * Broadcast Theme
 *
 * Hersey personalisation / engraving feature behaviour.
 */

(function() {

  // =========================================================================
  // ENGRAVING
  // =========================================================================

  // --- Modal ---

  var triggers = document.querySelectorAll('[data-engraving-trigger]');

  if (!triggers.length) return;

  var PERSONALISATION_COST_KEY = 'Personalisation Cost';
  var PERSONALISATION_CAPACITY_MESSAGE = 'A maximum of four personalisation positions can be saved.';
  var MAXIMUM_SUPPORTED_PERSONALISATION_POSITIONS = 4;
  var PERSONALISATION_COST_CURRENCY_SYMBOLS = {
    GBP: '\u00a3',
    USD: '$',
    EUR: '\u20ac'
  };

  function getEngravingBlock(element) {
    return element ? element.closest('[data-engraving-block]') : null;
  }

  function getMaximumEnteredPersonalisationPositions(block) {
    if (!block) return 0;

    var maximum = Number(block.getAttribute('data-maximum-entered-positions'));

    if (!Number.isInteger(maximum) || maximum < 1) return 0;
    if (maximum > MAXIMUM_SUPPORTED_PERSONALISATION_POSITIONS) return 0;

    return maximum;
  }

  function getCurrencyCode(element) {
    var block = getEngravingBlock(element);
    return block ? block.getAttribute('data-currency-code') : 'GBP';
  }

  function formatEngravingMoney(totalPence, element) {
    var currencyCode = getCurrencyCode(element) || 'GBP';
    var amount = (parseInt(totalPence, 10) || 0) / 100;

    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currencyCode
      }).format(amount);
    } catch (error) {
      return amount.toFixed(2) + ' ' + currencyCode;
    }
  }

  function formatPriceSummaryAmount(totalPence, element) {
    return formatEngravingMoney(totalPence, element);
  }

  function formatPersonalisationCostProperty(totalPence, element) {
    var currencyCode = (getCurrencyCode(element) || 'GBP').toUpperCase();
    var amount = (parseInt(totalPence, 10) || 0) / 100;
    var prefix = PERSONALISATION_COST_CURRENCY_SYMBOLS[currencyCode] || currencyCode + ' ';

    return prefix + amount.toFixed(2);
  }

  function getPriceSummaryConfig(element) {
    return {
      baseFee: element ? parseInt(element.getAttribute('data-base-fee'), 10) || 0 : 0,
      perChar: element ? parseInt(element.getAttribute('data-price-per-char'), 10) || 0 : 0
    };
  }

  function formatConfiguredPriceSummary(element) {
    var config = getPriceSummaryConfig(element);

    if (config.baseFee > 0) {
      return formatPriceSummaryAmount(config.baseFee, element);
    }

    if (config.perChar > 0) {
      return formatPriceSummaryAmount(config.perChar, element) + ' per character';
    }

    return '';
  }

  function updatePriceSummary(summary, amount, totalPence, element) {
    var value = parseInt(totalPence, 10) || 0;
    var configuredAmount = formatConfiguredPriceSummary(element);
    var hasSummary = value > 0 || configuredAmount !== '';

    if (summary) {
      summary.hidden = !hasSummary;
      summary.style.display = hasSummary ? '' : 'none';
    }

    if (!amount) return;

    if (!hasSummary) {
      amount.textContent = '';
      return;
    }

    amount.textContent = value > 0 ? formatPriceSummaryAmount(value, element) : configuredAmount;
  }

  var PERSONALISATION_CART_RETURN_KEY = 'herseyPersonalisationCartReturn';

  function getPersonalisationNavigationType() {
    try {
      if (!window.performance || typeof window.performance.getEntriesByType !== 'function') return '';

      var entries = window.performance.getEntriesByType('navigation');
      return entries && entries[0] && entries[0].type ? entries[0].type : '';
    } catch (error) {
      return '';
    }
  }

  function isPersonalisationHistoryRestore(event) {
    return Boolean((event && event.persisted) || getPersonalisationNavigationType() === 'back_forward');
  }

  function rememberCartDrawerCheckoutReturn(event) {
    var target = event.target && event.target.closest ? event.target.closest('.cart__checkout, button[name="checkout"]') : null;
    if (!target || !target.closest('cart-drawer')) return;

    try {
      sessionStorage.setItem(PERSONALISATION_CART_RETURN_KEY, '1');
    } catch (error) {
      return;
    }
  }

  function refreshCartDrawerAfterCheckoutReturn(event) {
    var cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;

    var shouldReopen = false;

    try {
      shouldReopen = sessionStorage.getItem(PERSONALISATION_CART_RETURN_KEY) === '1';
      sessionStorage.removeItem(PERSONALISATION_CART_RETURN_KEY);
    } catch (error) {
      shouldReopen = false;
    }

    var isHistoryRestore = isPersonalisationHistoryRestore(event);

    if (!isHistoryRestore) return;
    if (!shouldReopen && !cartDrawer.classList.contains('is-open')) return;

    document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));

    if (shouldReopen || cartDrawer.classList.contains('is-open')) {
      cartDrawer.dispatchEvent(new CustomEvent('theme:cart-drawer:show', { bubbles: true }));
    }
  }

  document.addEventListener('click', rememberCartDrawerCheckoutReturn, true);
  window.addEventListener('pageshow', refreshCartDrawerAfterCheckoutReturn);

  function countEngravingCharacters(value) {
    return Array.from(value || '').length;
  }

  function normaliseEngravingLineValue(value) {
    return String(value || '').trim();
  }

  function enteredEngravingLines(lines) {
    return lines.reduce(function(enteredLines, line, index) {
      var value = normaliseEngravingLineValue(line);

      if (value !== '') {
        enteredLines.push({
          index: index,
          value: value
        });
      }

      return enteredLines;
    }, []);
  }

  function normalisePersonalisationType(value) {
    return String(value || 'engraving').toLowerCase().replace(/_/g, '-').trim() || 'engraving';
  }

  function displayPersonalisationValue(set, value) {
    return value;
  }

  function enteredDisplayLinesForSet(set, values) {
    return values
      .map(function(value) { return normaliseEngravingLineValue(value); })
      .filter(function(value) { return value !== ''; })
      .map(function(value) { return displayPersonalisationValue(set, value); });
  }

  function firstEngravingLineValue(lines) {
    return normaliseEngravingLineValue((lines || [])[0] || '');
  }

  function enteredLineHasGap(lines) {
    var hasBlankBeforeEnteredLine = false;

    return (lines || []).some(function(line) {
      var value = normaliseEngravingLineValue(line);

      if (value === '') {
        hasBlankBeforeEnteredLine = true;
        return false;
      }

      return hasBlankBeforeEnteredLine;
    });
  }

  function personalisationFirstLineMessage(type) {
    if (type === 'date') return 'Enter a date before saving.';
    if (type === 'name') return 'Enter a name before saving.';
    if (type === 'initial' || type === 'stamped-initial') return 'Enter one initial.';
    if (type === 'monogram') return 'Enter 1 to 3 initials.';
    return 'Enter line 1 before saving.';
  }

  function validatePersonalisationLines(type, lines, maxLines, characterLimit) {
    var personalisationType = normalisePersonalisationType(type);
    var normalisedLines = Array.from(lines || []).map(normaliseEngravingLineValue);
    var errors = [];
    var hasContent = normalisedLines.some(function(value) { return value !== ''; });
    var effectiveMaxLines = maxLines || normalisedLines.length || 1;
    var effectiveCharacterLimit = characterLimit || 0;
    var firstLine = firstEngravingLineValue(normalisedLines);
    var firstLineLength = countEngravingCharacters(firstLine);
    var singleLineTypes = ['date', 'name', 'initial', 'monogram', 'stamped-initial'];

    if (!hasContent) {
      errors.push({ index: 0, message: personalisationFirstLineMessage(personalisationType) });
    } else if (firstLine === '') {
      errors.push({ index: 0, message: personalisationFirstLineMessage(personalisationType) });
    } else {
      var missingIndex = -1;

      normalisedLines.some(function(value, lineIndex) {
        if (value === '' && missingIndex === -1) {
          missingIndex = lineIndex;
          return false;
        }

        if (value !== '' && missingIndex !== -1) {
          errors.push({
            index: missingIndex,
            message: 'Enter line ' + (missingIndex + 1) + ' before using line ' + (lineIndex + 1) + '.'
          });
          return true;
        }

        return false;
      });
    }

    normalisedLines.forEach(function(line, lineIndex) {
      if (line === '') return;

      if (lineIndex >= effectiveMaxLines || (singleLineTypes.indexOf(personalisationType) !== -1 && lineIndex > 0)) {
        errors.push({ index: lineIndex, message: 'Use fewer lines for this personalisation.' });
      }

      if (effectiveCharacterLimit > 0 && countEngravingCharacters(line) > effectiveCharacterLimit) {
        errors.push({ index: lineIndex, message: 'Use ' + effectiveCharacterLimit + ' characters or fewer.' });
      }
    });

    if ((personalisationType === 'initial' || personalisationType === 'stamped-initial') && firstLine !== '' && firstLineLength !== 1) {
      errors.push({ index: 0, message: personalisationFirstLineMessage(personalisationType) });
    }

    if (personalisationType === 'monogram' && firstLineLength > 3) {
      errors.push({ index: 0, message: personalisationFirstLineMessage(personalisationType) });
    }

    return {
      valid: errors.length === 0,
      hasContent: hasContent,
      normalisedLines: normalisedLines,
      errors: errors
    };
  }

  function validatePersonalisationSet(set) {
    var inputs = set ? Array.from(set.querySelectorAll('[data-engraving-input]')) : [];
    var lines = inputs.map(function(input) { return normaliseEngravingLineValue(input.value); });
    var type = set ? set.getAttribute('data-personalisation-type') : 'engraving';
    var maxLines = set ? parseInt(set.getAttribute('data-max-lines'), 10) || inputs.length : inputs.length;
    var characterLimit = set ? parseInt(set.getAttribute('data-char-limit'), 10) || 0 : 0;

    return validatePersonalisationLines(type, lines, maxLines, characterLimit);
  }

  function personalisationPayloadCanIncludeSet(set, lines) {
    var type = set ? set.getAttribute('data-personalisation-type') : 'engraving';
    var maxLines = set ? parseInt(set.getAttribute('data-max-lines'), 10) || lines.length : lines.length;
    var characterLimit = set ? parseInt(set.getAttribute('data-char-limit'), 10) || 0 : 0;
    var validation = validatePersonalisationLines(type, lines, maxLines, characterLimit);

    return validation.hasContent && validation.valid;
  }

  function countEnteredPersonalisationSets(block) {
    if (!block) return 0;

    return Array.from(block.querySelectorAll('[data-engraving-set]')).reduce(function(count, set) {
      var lines = Array.from(set.querySelectorAll('[data-engraving-input]')).map(function(input) {
        return normaliseEngravingLineValue(input.value);
      });

      return count + (personalisationPayloadCanIncludeSet(set, lines) ? 1 : 0);
    }, 0);
  }

  function clearPersonalisationErrors(set) {
    if (!set) return;

    set.querySelectorAll('[data-engraving-field-invalid]').forEach(function(field) {
      field.removeAttribute('data-engraving-field-invalid');
    });
    set.querySelectorAll('[data-engraving-input]').forEach(function(input) {
      input.setAttribute('aria-invalid', 'false');
    });
    set.querySelectorAll('[data-engraving-error]').forEach(function(error) {
      error.textContent = '';
      error.hidden = true;
    });
  }

  function setPersonalisationErrors(set, errors) {
    if (!set) return;

    clearPersonalisationErrors(set);

    errors.forEach(function(error) {
      var input = set.querySelector('[data-engraving-line-index="' + error.index + '"]');
      var field = input && input.closest ? input.closest('.engraving-field') : null;
      var message = field ? field.querySelector('[data-engraving-error]') : null;

      if (!input || !field || !message) return;

      field.setAttribute('data-engraving-field-invalid', 'true');
      input.setAttribute('aria-invalid', 'true');
      message.textContent = error.message;
      message.hidden = false;
    });
  }

  function focusPersonalisationError(set, error) {
    if (!set || !error) return;

    var input = set.querySelector('[data-engraving-line-index="' + error.index + '"]');
    if (input) input.focus();
  }

  function refreshPersonalisationErrorsAfterAttempt(set) {
    if (!set || !set.hasAttribute('data-personalisation-validation-attempted')) return;

    var validation = validatePersonalisationSet(set);
    setPersonalisationErrors(set, validation.errors);

    if (validation.valid) {
      set.removeAttribute('data-personalisation-validation-attempted');
    }
  }

  function pushPersonalisationAttribute(attributes, key, value) {
    if (typeof value !== 'string' && typeof value !== 'number') return;

    var text = String(value).trim();
    if (text === '') return;

    attributes.push({
      key: key,
      value: text
    });
  }

  function buildSinglePersonalisationAttributes(attributes, location) {
    var type = normalisePersonalisationType(location.type);
    var enteredLines = enteredEngravingLines(location.lines || []);
    var firstLine = firstEngravingLineValue(location.lines || []);

    if (type === 'date') {
      pushPersonalisationAttribute(attributes, 'Personalisation Date', firstLine);
    } else if (type === 'name') {
      pushPersonalisationAttribute(attributes, 'Personalisation Name', firstLine);
    } else if (type === 'initial' || type === 'stamped-initial') {
      pushPersonalisationAttribute(attributes, 'Personalisation Initial', firstLine);
    } else if (type === 'monogram') {
      pushPersonalisationAttribute(attributes, 'Personalisation Monogram', firstLine);
    } else {
      pushPersonalisationAttribute(attributes, 'Personalisation Location', location.label || '');
      enteredLines.forEach(function(line) {
        pushPersonalisationAttribute(attributes, 'Personalisation Line ' + (line.index + 1), line.value);
      });
    }

    if (location.font) {
      pushPersonalisationAttribute(attributes, 'Personalisation Font', location.font);
    }

    if (location.choice) {
      pushPersonalisationAttribute(attributes, 'Personalisation Option', location.choice);
    }
  }

  function buildIndexedPersonalisationAttributes(attributes, location, index) {
    var prefix = 'Personalisation ' + index + ' ';
    var type = normalisePersonalisationType(location.type);
    var enteredLines = enteredEngravingLines(location.lines || []);
    var firstLine = firstEngravingLineValue(location.lines || []);

    pushPersonalisationAttribute(attributes, prefix + 'Location', location.label || '');

    if (type === 'date') {
      pushPersonalisationAttribute(attributes, prefix + 'Date', firstLine);
    } else if (type === 'name') {
      pushPersonalisationAttribute(attributes, prefix + 'Name', firstLine);
    } else if (type === 'initial' || type === 'stamped-initial') {
      pushPersonalisationAttribute(attributes, prefix + 'Initial', firstLine);
    } else if (type === 'monogram') {
      pushPersonalisationAttribute(attributes, prefix + 'Monogram', firstLine);
    } else {
      enteredLines.forEach(function(line) {
        pushPersonalisationAttribute(attributes, prefix + 'Line ' + (line.index + 1), line.value);
      });
    }

    if (location.font) {
      pushPersonalisationAttribute(attributes, prefix + 'Font', location.font);
    }

    if (location.choice) {
      pushPersonalisationAttribute(attributes, prefix + 'Option', location.choice);
    }
  }

  function buildPersonalisationAttributes(payload) {
    if (!payload || !payload.locations) return [];

    var enteredLocations = payload.locations.filter(function(location) {
      return enteredEngravingLines(location.lines || []).length > 0
        && firstEngravingLineValue(location.lines || []) !== ''
        && !enteredLineHasGap(location.lines || []);
    });

    if (!enteredLocations.length) return [];

    var attributes = [];

    pushPersonalisationAttribute(attributes, 'Personalisation', 'Yes');

    if (enteredLocations.length === 1) {
      buildSinglePersonalisationAttributes(attributes, enteredLocations[0]);
    } else {
      enteredLocations.forEach(function(location, index) {
        buildIndexedPersonalisationAttributes(attributes, location, index + 1);
      });
    }

    return attributes;
  }

  function updateVisiblePersonalisationInputs(container, attributes) {
    if (!container) return;

    var formId = container.getAttribute('data-product-form-id') || '';
    container.innerHTML = '';

    attributes.forEach(function(attribute) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[' + attribute.key + ']';
      input.value = attribute.value;
      input.setAttribute('data-personalisation-property', '');
      if (formId) input.setAttribute('form', formId);
      container.appendChild(input);
    });
  }

  function updateEngravingPayload(block) {
    if (!block) return;

    var payloadInput = block.querySelector('[data-engraving-payload]');
    var propertiesContainer = block.querySelector('[data-personalisation-properties]');
    if (!payloadInput && !propertiesContainer) return;

    var maximumEnteredPositions = getMaximumEnteredPersonalisationPositions(block);
    var locations = [];
    var personalisationCost = 0;

    block.querySelectorAll('[data-engraving-set]').forEach(function(set) {
      var inputs = Array.from(set.querySelectorAll('[data-engraving-input]'));
      var lines = inputs.map(function(input) { return normaliseEngravingLineValue(input.value); });
      var hasContent = personalisationPayloadCanIncludeSet(set, lines);

      if (!hasContent) return;

      var fontInput = set.querySelector('[data-engraving-font]');
      var optionInput = set.querySelector('[data-engraving-option]');

      locations.push({
        key: set.getAttribute('data-location-key') || '',
        type: normalisePersonalisationType(set.getAttribute('data-personalisation-type')),
        label: set.getAttribute('data-location-label') || '',
        lines: lines,
        font: fontInput && !fontInput.disabled ? fontInput.value : null,
        choice: optionInput && !optionInput.disabled ? optionInput.value : null
      });

      var costInput = set.querySelector('[data-engraving-cost]');
      personalisationCost += costInput ? parseInt(costInput.value, 10) || 0 : 0;
    });

    if (locations.length > maximumEnteredPositions) {
      if (payloadInput) payloadInput.value = '';
      updateVisiblePersonalisationInputs(propertiesContainer, []);
      return;
    }

    var payload = locations.length ? {
      version: 1,
      locations: locations
    } : null;
    var attributes = payload ? buildPersonalisationAttributes(payload) : [];

    if (payload) {
      pushPersonalisationAttribute(
        attributes,
        PERSONALISATION_COST_KEY,
        formatPersonalisationCostProperty(personalisationCost, block)
      );
    }

    if (payloadInput) {
      payloadInput.value = payload ? JSON.stringify(payload) : '';
    }
    updateVisiblePersonalisationInputs(propertiesContainer, attributes);
  }

  function updateEngravingPayloadFromSet(set) {
    updateEngravingPayload(getEngravingBlock(set));
  }

  function updateTriggerPricing(trigger, costInput, triggerPricing, hasContent) {
    if (!trigger) return;

    var totalPence    = costInput ? parseInt(costInput.value, 10) : 0;
    var triggerLabel  = trigger.querySelector('[data-engraving-trigger-label]');
    var statusRow     = trigger.querySelector('[data-engraving-trigger-status]');
    var locationMatch = triggerLabel ? triggerLabel.textContent.match(/\(.*\)/) : null;
    var location      = locationMatch ? ' ' + locationMatch[0] : '';
    var originalText  = triggerPricing ? (triggerPricing.getAttribute('data-original-pricing') || '') : '';
    var addLabel      = trigger.getAttribute('data-add-label') || 'Add Engraving';
    var editLabel     = trigger.getAttribute('data-edit-label') || 'Edit Engraving';
    var savedLabel    = trigger.getAttribute('data-saved-label') || 'Engraving saved';

    if (hasContent) {
      if (triggerPricing) {
        triggerPricing.textContent = totalPence > 0 ? savedLabel + ' (+' + formatEngravingMoney(totalPence, trigger) + ')' : savedLabel;
        triggerPricing.classList.add('engraving-trigger__pricing--active');
      }
      if (triggerLabel) triggerLabel.textContent = editLabel + location;
    } else {
      if (triggerPricing) {
        triggerPricing.textContent = originalText;
        triggerPricing.classList.remove('engraving-trigger__pricing--active');
      }
      if (triggerLabel) triggerLabel.textContent = addLabel + location;
    }

    if (statusRow) {
      statusRow.hidden = !hasContent && originalText.trim() === '';
    }
  }

  function openModal(modal, trigger) {
    modal.showModal();
    modal.removeAttribute('aria-hidden');
    modal.removeAttribute('inert');
    trigger.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('is-engraving-open');
    document.body.classList.add('is-engraving-open');
  }

  function setEngravingPreviewFont(preview, font) {
    if (!preview || preview.classList.contains('engraving-preview__text--monogram')) return;
    preview.style.fontFamily = font ? "'" + font + "', serif" : '';
  }

  function setEngravingPreviewText(preview, text, emptyLabel) {
    if (!preview) return;

    var previewText = text || '';
    var characters = Array.from(previewText);
    var isThreeCharacterMonogram = preview.classList.contains('engraving-preview__text--monogram')
      && characters.length === 3;

    preview.classList.toggle('engraving-preview__text--three-character-monogram', isThreeCharacterMonogram);
    preview.textContent = '';

    if (!isThreeCharacterMonogram) {
      preview.textContent = previewText || emptyLabel || 'ENGRAVING PREVIEW WILL DISPLAY HERE';
      return;
    }

    var positions = ['first', 'centre', 'last'];

    characters.forEach(function(character, index) {
      var characterElement = document.createElement('span');
      characterElement.className = 'engraving-preview__monogram-character engraving-preview__monogram-character--' + positions[index];
      characterElement.textContent = character;
      preview.appendChild(characterElement);
    });
  }

  function restoreState(modal, savedState) {

    var set         = modal.querySelector('[data-engraving-set]');
    var inputs      = set.querySelectorAll('[data-engraving-input]');
    var counters    = set.querySelectorAll('[data-char-used]');
    var fontInput   = set.querySelector('[data-engraving-font]');
    var fontButtons = set.querySelectorAll('[data-engraving-font-option]');
    var fontPopout  = set.querySelector('popout-select[data-engraving-font-selector]');
    var priceSummary = set.querySelector('[data-engraving-price-summary]');
    var priceAmount = set.querySelector('[data-engraving-price-amount]');
    var costInput   = set.querySelector('[data-engraving-cost]');
    var optionInput = set.querySelector('[data-engraving-option]');
    var popout      = optionInput ? optionInput.closest('popout-select') : null;

    clearPersonalisationErrors(set);
    set.removeAttribute('data-personalisation-validation-attempted');

    // If preview is disabled, this returns null — all preview blocks below guard against that
    var preview = set.closest('.engraving-modal__layout').querySelector('[data-engraving-preview-text]');

    if (savedState) {
      var hasSavedContent = savedState.inputs.some(function(value) { return normaliseEngravingLineValue(value) !== ''; });

      // Restore input values
      inputs.forEach(function(input, i) {
        input.value = savedState.inputs[i] || '';
      });

      // Restore character counters
      counters.forEach(function(counter, i) {
        counter.textContent = savedState.inputs[i] ? countEngravingCharacters(normaliseEngravingLineValue(savedState.inputs[i])) : '0';
      });

      // Restore font — including on the text inputs themselves
      if (fontInput) {
        fontInput.value    = savedState.font;
        fontInput.disabled = !hasSavedContent;
      }
      fontButtons.forEach(function(btn) {
        btn.classList.toggle('is-selected', btn.getAttribute('data-value') === savedState.font);
      });
      if (fontPopout) {
        var ftToggle = fontPopout.querySelector('[data-popout-toggle-text]');
        if (ftToggle) {
          ftToggle.textContent = savedState.font;
          ftToggle.style.fontFamily = "'" + savedState.font + "', serif";
        }
        fontPopout.querySelectorAll('[data-popout-option]').forEach(function(opt) {
          var isMatch = opt.getAttribute('data-value') === savedState.font;
          opt.setAttribute('aria-current', isMatch ? 'true' : 'false');
          opt.closest('.select-popout__item').classList.toggle('is-active', isMatch);
        });
      }
      inputs.forEach(function(input) {
        input.style.fontFamily = "'" + savedState.font + "', serif";
      });

      // Restore option selector
      if (optionInput && savedState.option !== null) {
        optionInput.value    = savedState.option;
        optionInput.disabled = !hasSavedContent;
        if (popout) {
          var toggleText = popout.querySelector('[data-popout-toggle-text]');
          if (toggleText) toggleText.textContent = savedState.option;
          popout.querySelectorAll('[data-popout-option]').forEach(function(opt) {
            var isMatch = opt.getAttribute('data-value') === savedState.option;
            opt.setAttribute('aria-current', isMatch ? 'true' : 'false');
            opt.closest('.select-popout__item').classList.toggle('is-active', isMatch);
          });
        }
      }

      // Restore price summary
      updatePriceSummary(priceSummary, priceAmount, savedState.cost, set);
      if (costInput) costInput.value = savedState.cost;

      // Restore preview
      if (preview) {
        var lines = enteredDisplayLinesForSet(set, savedState.inputs);
        var text  = lines.join('\n');
        setEngravingPreviewText(
          preview,
          text,
          set.getAttribute('data-preview-empty-label') || 'ENGRAVING PREVIEW WILL DISPLAY HERE'
        );
        setEngravingPreviewFont(preview, savedState.font);
        if (text) {
          preview.classList.add('has-content');
        } else {
          preview.classList.remove('has-content');
        }
      }

    } else {

      // No saved state — reset to defaults
      var defaultFont = set.getAttribute('data-default-font') || '';
      var allFontBtns = set.querySelectorAll('[data-engraving-font-option]');

      inputs.forEach(function(input) {
        input.value = '';
        input.style.fontFamily = defaultFont ? "'" + defaultFont + "', serif" : '';
      });
      counters.forEach(function(counter) { counter.textContent = '0'; });
      allFontBtns.forEach(function(btn) {
        btn.classList.toggle('is-selected', btn.getAttribute('data-value') === defaultFont);
      });
      if (fontPopout) {
        var ftToggle = fontPopout.querySelector('[data-popout-toggle-text]');
        if (ftToggle) {
          ftToggle.textContent = defaultFont;
          ftToggle.style.fontFamily = defaultFont ? "'" + defaultFont + "', serif" : '';
        }
        fontPopout.querySelectorAll('[data-popout-option]').forEach(function(opt, i) {
          opt.setAttribute('aria-current', i === 0 ? 'true' : 'false');
          opt.closest('.select-popout__item').classList.toggle('is-active', i === 0);
        });
      }
      if (fontInput) {
        fontInput.value    = defaultFont;
        fontInput.disabled = true;
      }
      if (optionInput) optionInput.disabled = true;
      updatePriceSummary(priceSummary, priceAmount, 0, set);
      if (costInput) costInput.value = '0';
      if (preview) {
        setEngravingPreviewText(
          preview,
          '',
          set.getAttribute('data-preview-empty-label') || 'ENGRAVING PREVIEW WILL DISPLAY HERE'
        );
        setEngravingPreviewFont(preview, defaultFont);
        preview.classList.remove('has-content');
      }

      // Reset option selector to first option
      if (optionInput && popout) {
        var firstOption = popout.querySelector('[data-popout-option]');
        if (firstOption) {
          var defaultValue = firstOption.getAttribute('data-value');
          optionInput.value = defaultValue;
          var toggleText = popout.querySelector('[data-popout-toggle-text]');
          if (toggleText) toggleText.textContent = defaultValue;
          popout.querySelectorAll('[data-popout-option]').forEach(function(opt, i) {
            opt.setAttribute('aria-current', i === 0 ? 'true' : 'false');
            opt.closest('.select-popout__item').classList.toggle('is-active', i === 0);
          });
        }
      }

    }

    updateEngravingPayloadFromSet(set);
  }

  // closeModal sets the commit flag then calls modal.close().
  // The native 'close' event fires for every close path — button, backdrop, and
  // Escape key — and handles all ARIA/inert updates and state restoration from there.
  function closeModal(modal, trigger, commit) {
    modal._commitClose = commit;
    modal.close();
  }

  triggers.forEach(function(trigger) {

    var modalId        = trigger.getAttribute('data-modal-target');
    var modal          = document.getElementById(modalId);

    if (!modal) return;

    var closeBtn       = modal.querySelector('[data-engraving-modal-close]');
    var saveBtn        = modal.querySelector('[data-engraving-modal-save]');
    var exitBtn        = modal.querySelector('[data-engraving-modal-exit]');
    var triggerPricing = trigger.querySelector('[data-engraving-trigger-pricing]');
    var removeBtn      = trigger.querySelector('[data-engraving-remove]');
    var set            = modal.querySelector('[data-engraving-set]');

    // savedState holds the last committed snapshot — null until first Save
    var savedState = null;

    // Store the original pricing text so we can restore it if cost drops to zero
    if (triggerPricing) {
      triggerPricing.setAttribute('data-original-pricing', triggerPricing.textContent.trim());
    }

    // Open
    trigger.addEventListener('click', function() {
      modal.setAttribute('aria-label', savedState ? (trigger.getAttribute('data-edit-label') || 'Edit Engraving') : (trigger.getAttribute('data-add-label') || 'Add Engraving'));
      openModal(modal, trigger);
    });

    // Close button — discard changes, restore to saved state
    if (closeBtn) closeBtn.addEventListener('click', function() {
      closeModal(modal, trigger, false);
    });

    // Exit button — same as close: discard changes
    if (exitBtn) exitBtn.addEventListener('click', function() {
      closeModal(modal, trigger, false);
    });

    // Save button — take snapshot, then close committing the new state
    if (saveBtn) saveBtn.addEventListener('click', function() {
      var inputs      = set.querySelectorAll('[data-engraving-input]');
      var fontInput   = set.querySelector('[data-engraving-font]');
      var costInput   = set.querySelector('[data-engraving-cost]');
      var optionInput = set.querySelector('[data-engraving-option]');

      inputs.forEach(function(input) {
        input.value = normaliseEngravingLineValue(input.value);
      });

      var validation = validatePersonalisationSet(set);

      if (!validation.valid) {
        set.setAttribute('data-personalisation-validation-attempted', 'true');
        setPersonalisationErrors(set, validation.errors);
        focusPersonalisationError(set, validation.errors[0]);
        return;
      }

      var block = getEngravingBlock(set);
      var maximumEnteredPositions = getMaximumEnteredPersonalisationPositions(block);
      var enteredSetCount = countEnteredPersonalisationSets(block);

      if (enteredSetCount > maximumEnteredPositions) {
        var capacityError = { index: 0, message: PERSONALISATION_CAPACITY_MESSAGE };
        set.setAttribute('data-personalisation-validation-attempted', 'true');
        setPersonalisationErrors(set, [capacityError]);
        focusPersonalisationError(set, capacityError);
        return;
      }

      set.removeAttribute('data-personalisation-validation-attempted');
      clearPersonalisationErrors(set);

      savedState = {
        inputs: Array.from(inputs).map(function(input) { return normaliseEngravingLineValue(input.value); }),
        font:   fontInput ? fontInput.value : '',
        cost:   costInput ? parseInt(costInput.value, 10) : 0,
        option: optionInput ? optionInput.value : null
      };

      updateEngravingPayloadFromSet(set);
      closeModal(modal, trigger, true);
    });

    // Remove button — clear engraving without opening the modal
    if (removeBtn) removeBtn.addEventListener('click', function(event) {
      event.stopPropagation();
      savedState = null;
      restoreState(modal, null);
      var costInput = set ? set.querySelector('[data-engraving-cost]') : null;
      updateEngravingPayloadFromSet(set);
      updateTriggerPricing(trigger, costInput, triggerPricing, false);
      removeBtn.style.display = 'none';
    });

    // Backdrop click — discard changes, restore to saved state
    modal.addEventListener('click', function(event) {
      if (event.target === modal) {
        closeModal(modal, trigger, false);
      }
    });

    // Single 'close' handler covers all close paths: button, backdrop, Escape key.
    // modal._commitClose is set by closeModal() before modal.close() is called,
    // so by the time this fires we know whether to restore state or leave it alone.
    modal.addEventListener('close', function() {
      modal.setAttribute('aria-hidden', 'true');
      modal.setAttribute('inert', '');
      document.documentElement.classList.remove('is-engraving-open');
      document.body.classList.remove('is-engraving-open');
      trigger.setAttribute('aria-expanded', 'false');

      if (!modal._commitClose) {
        restoreState(modal, savedState);
      }

      var costInput = set ? set.querySelector('[data-engraving-cost]') : null;
      var hasContent = savedState && savedState.inputs.some(function(v) { return normaliseEngravingLineValue(v) !== ''; });
      updateTriggerPricing(trigger, costInput, triggerPricing, hasContent);

      if (removeBtn) {
        removeBtn.style.display = hasContent ? '' : 'none';
      }

      modal._commitClose = false;
    });

    // Reset engraving state after a successful add to cart.
    // Broadcast fires 'theme:product:add' as a bubbling DOM event on the submit button.
    document.addEventListener('theme:product:add', function() {
      savedState = null;
      restoreState(modal, null);
      var costInput = set ? set.querySelector('[data-engraving-cost]') : null;
      updateEngravingPayloadFromSet(set);
      updateTriggerPricing(trigger, costInput, triggerPricing, false);
      if (removeBtn) removeBtn.style.display = 'none';
    });

  });

  // --- Uppercase Enforcement ---

  var engravingInputs = document.querySelectorAll('[data-engraving-input]');

  engravingInputs.forEach(function(input) {
    var set = input.closest('[data-engraving-set]');
    if (!set || !set.hasAttribute('data-engraving-uppercase')) return;

    input.addEventListener('input', function() {
      var pos = input.selectionStart;
      input.value = input.value.toUpperCase();
      input.setSelectionRange(pos, pos);
    });
  });

  // --- Prevent Enter submitting the product form; advance to next field on mobile ---

  engravingInputs.forEach(function(input) {
    input.addEventListener('keydown', function(event) {
      if (event.key !== 'Enter') return;
      event.preventDefault();
      var set    = input.closest('[data-engraving-set]');
      var inputs = Array.from(set.querySelectorAll('[data-engraving-input]'));
      var next   = inputs[inputs.indexOf(input) + 1];
      if (next) next.focus(); else input.blur();
    });
  });

  // --- Character Counter ---

  engravingInputs.forEach(function(input) {

    var counter = input.closest('.engraving-field').querySelector('[data-char-used]');

    if (!counter) return;

    input.addEventListener('input', function() {
      counter.textContent = countEngravingCharacters(input.value);
    });

  });

  // --- Personalisation Validation ---

  engravingInputs.forEach(function(input) {
    input.addEventListener('input', function() {
      refreshPersonalisationErrorsAfterAttempt(input.closest('[data-engraving-set]'));
    });
  });

  // --- Preview Text ---

  var engravingSets = document.querySelectorAll('[data-engraving-set]');

  engravingSets.forEach(function(set) {

    var inputs  = set.querySelectorAll('[data-engraving-input]');
    var preview = set.closest('.engraving-modal__layout').querySelector('[data-engraving-preview-text]');

    if (!preview) return;

    function updatePreview() {

      var lines = Array.from(inputs)
        .map(function(input) { return normaliseEngravingLineValue(input.value); })
        .filter(function(value) { return value !== ''; })
        .map(function(value) { return displayPersonalisationValue(set, value); });

      var text = lines.join('\n');

      setEngravingPreviewText(
        preview,
        text,
        set.getAttribute('data-preview-empty-label') || 'ENGRAVING PREVIEW WILL DISPLAY HERE'
      );

      if (text) {
        preview.classList.add('has-content');
      } else {
        preview.classList.remove('has-content');
      }
    }

    inputs.forEach(function(input) {
      input.addEventListener('input', updatePreview);
    });

  });

  // --- Font Selector ---

  engravingSets.forEach(function(set) {

    var fontOptions = set.querySelectorAll('[data-engraving-font-option]');
    var fontInput   = set.querySelector('[data-engraving-font]');
    var fontPopout  = set.querySelector('popout-select[data-engraving-font-selector]');
    var preview     = set.closest('.engraving-modal__layout').querySelector('[data-engraving-preview-text]');

    if (!fontOptions.length) return;

    function setFont(font) {
      if (fontInput) fontInput.value = font;
      setEngravingPreviewFont(preview, font);
      set.querySelectorAll('[data-engraving-input]').forEach(function(input) {
        input.style.fontFamily = "'" + font + "', serif";
      });
      if (fontPopout) {
        var toggleText = fontPopout.querySelector('[data-popout-toggle-text]');
        if (toggleText) toggleText.style.fontFamily = "'" + font + "', serif";
      }
      updateEngravingPayloadFromSet(set);
    }

    // Pills: use is-selected button. Dropdown: use hidden input value.
    var selectedBtn = set.querySelector('[data-engraving-font-option].is-selected');
    var defaultFont = selectedBtn ? selectedBtn.getAttribute('data-value') : (fontInput ? fontInput.value : '');
    if (defaultFont) {
      set.setAttribute('data-default-font', defaultFont);
      setFont(defaultFont);
    }

    fontOptions.forEach(function(option) {
      option.addEventListener('click', function() {
        if (!fontPopout) {
          fontOptions.forEach(function(btn) { btn.classList.remove('is-selected'); });
          option.classList.add('is-selected');
        }
        setFont(option.getAttribute('data-value'));
      });
    });

  });

  // --- Price Summary ---

  engravingSets.forEach(function(set) {

    var inputs      = set.querySelectorAll('[data-engraving-input]');
    var priceSummary = set.querySelector('[data-engraving-price-summary]');
    var priceAmount = set.querySelector('[data-engraving-price-amount]');
    var costInput   = set.querySelector('[data-engraving-cost]');
    var fontInput   = set.querySelector('[data-engraving-font]');
    var optionInput = set.querySelector('[data-engraving-option]');
    var baseFee     = parseInt(set.getAttribute('data-base-fee'), 10) || 0;
    var perChar     = parseInt(set.getAttribute('data-price-per-char'), 10) || 0;

    if (!priceAmount && !fontInput && !optionInput) return;

    function updatePrice() {

      var totalChars = 0;
      inputs.forEach(function(input) {
        totalChars += countEngravingCharacters(normaliseEngravingLineValue(input.value));
      });

      var totalPence  = totalChars > 0 ? baseFee + (perChar * totalChars) : 0;

      updatePriceSummary(priceSummary, priceAmount, totalPence, set);
      if (costInput) costInput.value = totalPence;

      // Only submit font and option if engraving text has been entered
      if (fontInput) fontInput.disabled = totalChars === 0;
      if (optionInput) optionInput.disabled = totalChars === 0;
      updateEngravingPayloadFromSet(set);
    }

    updatePrice();

    inputs.forEach(function(input) {
      input.addEventListener('input', updatePrice);
    });

    if (optionInput) {
      optionInput.addEventListener('change', function() {
        updateEngravingPayloadFromSet(set);
      });

      var optionPopout = optionInput.closest('popout-select');
      if (optionPopout) {
        optionPopout.querySelectorAll('[data-popout-option]').forEach(function(option) {
          option.addEventListener('click', function() {
            window.requestAnimationFrame(function() {
              updateEngravingPayloadFromSet(set);
            });
          });
        });
      }
    }

  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
